import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.common.white,
      height: "100%",
    },
    panel: {
      width: "100%",
      margin: "0px !important",
      paddingBottom: "20px",
    },
    hiddenPanel: {
      width: "0%",
      height: "0%",
      paddingBottom: "0px",
      display: "none",
    },
  })
);
